/**
 * Shared export utilities — CSV download and Print-to-PDF
 * All exports include attribution: BTTCP app by Sandeep Maheshwari
 */

const ATTRIBUTION = 'Created from BTTCP app by Sandeep Maheshwari';

/** Download data as a CSV file — auto-appends attribution footer */
export function downloadCSV(filename, headers, rows) {
  const all = [];
  if (headers && headers.length > 0) all.push(headers);
  all.push(...rows);
  // Attribution footer
  all.push([]);
  all.push([ATTRIBUTION]);
  all.push([`Generated: ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}`]);

  const csv = all.map(row =>
    row.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(',')
  ).join('\n');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  a.download = `${filename}_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

/** Open browser print dialog — user saves as PDF */
export function printPage() {
  // Inject attribution footer for print
  const existing = document.getElementById('btccp-print-footer');
  if (!existing) {
    const footer = document.createElement('div');
    footer.id = 'btccp-print-footer';
    footer.innerHTML = `${ATTRIBUTION} · Generated ${new Date().toLocaleDateString('en-IN', { timeZone:'Asia/Kolkata', day:'numeric', month:'long', year:'numeric' })}`;
    document.body.appendChild(footer);
  }
  window.print();
}

/** Inject global print CSS with attribution footer on every PDF page */
export function injectGlobalPrintCSS() {
  if (document.getElementById('btccp-global-print-css')) return;
  const style = document.createElement('style');
  style.id = 'btccp-global-print-css';
  style.textContent = `
    @media print {
      .no-print { display: none !important; }
      body { background: #fff !important; color: #000 !important; font-size: 10pt; }
      * { -webkit-print-color-adjust: exact; color-adjust: exact; }

      #btccp-print-footer {
        display: block !important;
        position: fixed;
        bottom: 0; left: 0; right: 0;
        text-align: center;
        font-size: 8pt;
        color: #666;
        border-top: 1px solid #ccc;
        padding: 4px 0;
        background: #fff;
      }
    }
    #btccp-print-footer { display: none; }
  `;
  document.head.appendChild(style);
}
